import { useEffect, useState } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/index';
import { Stakeholder } from '../../types/stakeholder.types';
import { useAppQuery, useDebounce, useInvalidateQueries } from '../index';

export const useStakeholderByEmail = ({ email }: { email: string }) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_TEAM_MEMBER_BY_EMAIL);

  const [emailAfterDebounce, setEmail] = useState('');

  const companyId = selectedCompanyStorage(({ companyId }) => companyId);

  const { debounceCallback } = useDebounce<string>({
    callback: (value) => {
      setEmail(value);
    },
  });

  useEffect(() => {
    debounceCallback(email);
  }, [debounceCallback, email]);

  const { data: stakeholder, isLoading } = useAppQuery({
    defaultErrorHandling: false,
    queryKey: [QueryKey.GET_TEAM_MEMBER_BY_EMAIL, emailAfterDebounce],
    queryFn: () =>
      ApiService.get<Stakeholder>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', 'by-email', emailAfterDebounce || ''],
      }),
    enabled: !!emailAfterDebounce && emailAfterDebounce === email,
    retry: false,
  });

  return {
    invalidateQuery,
    stakeholder,
    isLoading,
  };
};
